import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {codPaymentReferenceCodeStatuses} from "../../../constants/constants";

const CodPaymentRefCodeStatusFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    loading,
    disabled
}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {showLabel && <h5>{"Durum"}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="codPaymentRefCodeStatus"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                loading={loading}
                disabled={disabled || loading}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="status_option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                {codPaymentReferenceCodeStatuses.map(status => (
                    <SelectField.Option
                        data-testid="status_option"
                        value={status.value}
                        key={status.value}
                    >
                        {t(`codPaymentReferenceCodeStatuses.${status.translation_key}`, {
                            ns: "codPayment"
                        })}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default CodPaymentRefCodeStatusFilter;
